import { render, staticRenderFns } from "./item-table.vue?vue&type=template&id=c3edc1a6&scoped=true"
import script from "./item-table.vue?vue&type=script&lang=ts"
export * from "./item-table.vue?vue&type=script&lang=ts"
import style0 from "./item-table.vue?vue&type=style&index=0&id=c3edc1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3edc1a6",
  null
  
)

export default component.exports